import React, { useEffect, useState, useRef } from "react";
import NavigateButtons from "components/NavigateButtons";
import { getCorrectPdfScale, goToTop } from "helpers/helpers";
import { useFormik } from "formik";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import ProgressBar from "react-bootstrap/ProgressBar";
import { base64ToFilePdf } from "helpers/helpers";
import { toast } from "react-toastify";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Step9({ currentStep, setCurrentStep, stepsState, setLoading }) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState,
      onSubmit: values => {
         goToTop();
         finishContract();
      },
   });

   const [numPages, setNumPages] = useState(null);
   const [pageNumber, setPageNumber] = useState(1);
   const [pdf, setPdf] = useState(null);
   const [progress, setProgress] = useState(10);
   const refToTitle = useRef(null);
   const windowWidth = window.innerWidth;
   const pdfScale = getCorrectPdfScale(windowWidth);
   let todayDate = new Date().toJSON().slice(0, 10).replace(/-/g, "/");

   function onDocumentLoadSuccess({ numPages }) {
      setNumPages(numPages);
   }

   const getPdfFromServer = async () => {
      var opportunityId = stepsState.opportunityId;
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
         return false;
      }
      window.dataLayer.push({ event: "pas_9_casnici_inceput_preluare_contract", info: { pagina: "step-9", finalizat: "nu", eroare: "nu", generat: "nu" } });
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS9, RequestMethod.POST, {
         data: { opportunityID: stepsState.opportunityId },
      });
      window.dataLayer.push({ event: "pas_9_casnici_finalizare_preluare_contract", info: { pagina: "step-9", finalizat: "nu", eroare: "nu", generat: "da" } });
      return response.response;
   };

   const finishContract = async () => {
      setLoading(true);
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS10, RequestMethod.POST, {
         data: { opportunityID: stepsState.opportunityId },
      });
      if (response.isSuccess) {
         window.dataLayer.push({ event: "pas_9_casnici", info: { pagina: "step-9", finalizat: "da" } });
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setCurrentStep(currentStep + 1);
      } else {
         toast.error("Finalizarea ultimului pas a esuat. Va rugam incercati din nou.");
      }
      setLoading(false);
   };

   const clearProgressBar = () => {
      setProgress(5);
   };

   const startProgressBar = () => {
      clearProgressBar();
      const interval = setInterval(() => {
         setProgress(prevProgress => {
            if (prevProgress >= 100) {
               clearInterval(interval);
               return 95;
            } else {
               return prevProgress + 10;
            }
         });
      }, 1100);
   };

   const pdfRenderError = () => {
      window.dataLayer.push({ event: "pas_9_casnici_eroare_procesare_contract", info: { pagina: "step-9", finalizat: "nu", eroare: "da" } })
      toast.error("Contractul dvs. nu a putut fi generat. Va rugam faceți refresh la pagina.");
      return <p>Contractul dvs. nu a putut fi generat. Va rugam d-ați refresh la pagina.</p>;
   };

   useEffect(() => {
      startProgressBar();
      //asteapta pdf de la server si converteste-l pentru a putea fi afisat
      const convertPdf = async () => {
         const response = await getPdfFromServer();
         window.dataLayer.push({ event: "pas_9_casnici_contract_generat", info: { pagina: "step-9", finalizat: "nu", eroare: "nu", generat: "da" } })
         setPdf(URL.createObjectURL(base64ToFilePdf(response)));
      };
      convertPdf();
   }, []);

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <form onSubmit={formik.handleSubmit}>
                     <div className="pas-9">
                        <h2 className="first_title" ref={refToTitle}>
                           Previzualizează și confirmă contractul și documentele tale
                        </h2>
                        <div className="mx-auto text-center">
                           <div className="pdf-container">
                              <Document
                                 file={{ url: pdf }}
                                 onLoadSuccess={onDocumentLoadSuccess}
                                 loading={
                                    <div className="mt-5 mb-4">
                                       <p className="text-center">Generăm contractul și documentele tale în format PDF. Te rugăm să aștepți...</p>
                                       <ProgressBar animated min={0} max={100} now={progress} />
                                    </div>
                                 }
                                 error={pdfRenderError}
                              >
                                 <Page scale={pdfScale} renderMode="svg" pageNumber={pageNumber} />
                                 <p className="text-center">
                                    <button
                                       type="button"
                                       className="pdfButton"
                                       onClick={() => {
                                          setPageNumber(pageNumber - 1);
                                          refToTitle.current.scrollIntoView({ behavior: "smooth" });
                                       }}
                                       disabled={pageNumber === 1}
                                    >
                                       <img src={require("assets/images/arrowLeft.png")} alt="" />
                                    </button>
                                    {pageNumber}/{numPages}
                                    <button
                                       type="button"
                                       className="pdfButton"
                                       onClick={() => {
                                          setPageNumber(pageNumber + 1);
                                          refToTitle.current.scrollIntoView({ behavior: "smooth" });
                                       }}
                                       disabled={pageNumber === numPages}
                                    >
                                       <img src={require("assets/images/arrowRight.png")} alt="" />
                                    </button>
                                 </p>
                              </Document>
                           </div>

                           {pdf && (
                              <a href={pdf} download={`Contract_PE_${todayDate}`} className="capture-button download-button" onClick={() => {
                                 window.dataLayer.push({ event: "pas_9_contract_descarcat", info: { pagina: "step-9", finalizat: "nu" } });
                              }}>
                                 Descarcă documentul PDF cu contractul tău
                              </a>
                           )}
                        </div>
                     </div>
                     {pdf ? (
                             <NavigateButtons  currentStep={currentStep} setCurrentStep={setCurrentStep} finalize={true}/>
                     ) : (
                         <div className="pb-50">
                            <p className="mt-20 text-center">În acest moment se generează contractul.</p>
                         </div>
                     )}
                  </form>
               </div>
            </div>
         </div>
      </section>
   );
}
